(function ($, Drupal) {
  // Slider init
  Drupal.behaviors.initSlider = {
    attach(context, settings) {
      $(".js_initSlider", context)
        .once("initSlider")
        .each(function () {
          // Wrap LS blocks in wrapper div
          const $this = $(this);
          const $slide = $this.find(".lifestyle");
          let $dir = false;

          $slide.each(function () {
            $(this).wrap("<div class='slider__item'></div>");
          });

          // If arabic revert slides
          if ($("body").hasClass("rtl")) {
            $dir = true;
          }

          if ($this.hasClass("slider--TIMELINE")) {
            if ($this.hasClass("first-slider")) {
              // Dots position always in the middle
              const $slideShow = $(".slider--TIMELINE.first-slider");

              function offsetDots(slideNum) {
                const $slickDots = $slideShow.find(".slick-dots");
                const numDots = $slickDots.find("li").length;
                const dotWidth = $slickDots.find("li:first").outerWidth(true);
                const offset = dotWidth * slideNum;

                // Offset the dots container to center current slide's dot
                $slickDots.css(
                  "marginLeft",
                  offset * -1 - Math.ceil(dotWidth / 2)
                );

                // Clear existing secondary dot class
                $slickDots.find("li").removeClass("slick-secondary");
                // Add secondary dot class to preceeding slide dot
                if (slideNum > 0) {
                  $slickDots
                    .find(`li:nth-of-type(${slideNum})`)
                    .addClass("slick-secondary");
                }
                // Add secondary dot class to next slide dot
                if (slideNum < numDots - 1) {
                  $slickDots
                    .find(`li:nth-of-type(${slideNum + 2})`)
                    .addClass("slick-secondary");
                }
              }

              $slideShow.on("init", function (event, slick) {
                offsetDots(0);
              });

              $slideShow.on("beforeChange", function (
                event,
                slick,
                currentSlide,
                nextSlide
              ) {
                offsetDots(nextSlide);
              });

              $slideShow.not('.slick-initialized').addClass("is_initiated").slick({
                lazyLoad: "ondemand",
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $dir,
                dots: true,
                arrows: false,
                infinite: true,
                fade: true,
                autoplay: false,
                asNavFor: ".slider--TIMELINE.second-slider",
                autoplaySpeed: 4444,
                cssEase: "linear"
              });
            } else if ($this.hasClass("second-slider")) {
              $this.not('.slick-initialized').addClass("is_initiated").slick({
                lazyLoad: "ondemand",
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $dir,
                dots: false,
                arrows: false,
                infinite: true,
                fade: true,
                autoplay: false,
                asNavFor: ".slider--TIMELINE.first-slider",
                autoplaySpeed: 4444,
                draggable: false,
                swipe: false,
                swipeToSlide: false,
                touchMove: false,
                cssEase: "linear"
              });
            } else {
              $this.not('.slick-initialized').addClass("is_initiated").slick({
                lazyLoad: "ondemand",
                slidesToShow: 1,
                slidesToScroll: 1,
                rtl: $dir,
                dots: true,
                arrows: false,
                infinite: true,
                fade: true,
                autoplay: true,
                autoplaySpeed: 4444,
                cssEase: "linear",
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      autoplay: false,
                      fade: false
                    }
                  }
                ]
              });
            }

            // Special case for two sliders Womens day / While Bleeding - add text ul to a slick dots ul
            if ($(".slider--TIMELINE.first-slider").length) {
              const timelineTitle = [];
              $(".slider--TIMELINE.first-slider").each(function () {
                $(this)
                  .find(".lifestyle--TIMELINE")
                  .once()
                  .each(function () {
                    timelineTitle.push(
                      $(this)
                        .find(".lifestyle__heading")
                        .html()
                    );
                  });
                $(this)
                  .find(".slick-dots li")
                  .once()
                  .each(function (index) {
                    $(this)
                      .find("button")
                      .html(
                        `<span class="timeline-year">${timelineTitle[index]}</span>`
                      );
                  });
              });
            }

            // Button open/close second slider
            $(".timeline-open-close")
              .once()
              .click(function (e) {
                const firstSlider = $(".slider--TIMELINE.first-slider");
                const secondSlider = $(".slider--TIMELINE.second-slider");
                const firstSliderHeight = firstSlider
                  .find(".slick-list")
                  .css("height");
                const secondSliderHeight = secondSlider
                  .find(".slick-list")
                  .css("height");

                $(this).toggleClass("opened");
                firstSlider.toggleClass("closed");
                secondSlider.toggleClass("opened");

                if (firstSlider.hasClass("closed")) {
                  secondSlider.css("height", firstSliderHeight);
                  firstSlider.css("height", "0");
                } else {
                  firstSlider.css("height", secondSliderHeight);
                  secondSlider.css("height", "0");
                }
                // Fake scroll smooth to the top of element slider
                const scrollValue = firstSlider.offset().top - 100;
                $("html, body").animate({scrollTop: scrollValue}, 500);
                return false;
              });
          } else if ($this.hasClass("slider--COMPLEX")) {
            // WB video slider
            $this.not('.slick-initialized').addClass("is_initiated").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              dots: true,
              arrows: true,
              cssEase: "linear",
              appendDots: $(this)
                .parents(".lifestyle__wrap")
                .find(".lifestyle__text-wrapper")
            });
          } else if ($this.hasClass("slider--PLAIN")) {
            $this.not('.slick-initialized').addClass("is_initiated").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              appendDots: $(this)
                .parents(".lifestyle__wrap")
                .find(".lifestyle__text-wrapper")
            });
          } else if ($this.hasClass("campaign__slider_2")) {
            $this.not('.slick-initialized').addClass("is_initiated").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              dots: true,
              arrows: false,
              cssEase: "linear",
              appendDots: $(this)
                .parents(".campaign__inner")
                .find(".campaign__text")
            });
          } else if ($this.hasClass("campaign__slider")) {
            // WB video slider
            $this.not('.slick-initialized').addClass("is_initiated").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              dots: true,
              arrows: true,
              cssEase: "linear",
              appendDots: $(this)
                .parents(".campaign__inner")
                .find(".campaign__text")
            });
          } else if ($this.hasClass("campaign__slider_3")) {
            $this.not('.slick-initialized').addClass("is_initiated").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              rtl: $dir,
              centerMode: false,
              dots: true,
              arrows: true,
              infinite: true,
              fade: true,
              autoplay: false,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    fade: false
                  }
                }
              ]
            });
          } else if ($this.hasClass("campaign__slider_4")) {
            $this.not('.slick-initialized').addClass("is_initiated").slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              rtl: $dir,
              centerMode: false,
              dots: true,
              arrows: false,
              infinite: true,
              fade: true,
              autoplay: false,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    fade: false
                  }
                }
              ]
            });
          } else {
            $this.not('.slick-initialized').addClass("is_initiated").slick({
              lazyLoad: "ondemand",
              slidesToShow: 1,
              slidesToScroll: 1,
              rtl: $dir,
              dots: true,
              arrows: true,
              infinite: true,
              fade: true,
              autoplay: true,
              autoplaySpeed: 4444,
              cssEase: "linear",
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    autoplay: false,
                    fade: false
                  }
                }
              ]
            });
          }
        });

      // On document ready add first slider height
      $(document).ready(function () {
        if ($(".slider--TIMELINE.first-slider").length) {
          setTimeout(function () {
            const firstSlider = $(".slider--TIMELINE.first-slider");
            const firstSliderHeight = firstSlider.css("height");
            firstSlider.css("height", firstSliderHeight);
          }, 1000);
        }
      });

      // On resize check timeline slider height
      $(window).on("resize", function () {
        if ($(".slider--TIMELINE.first-slider").length) {
          setTimeout(function () {
            const firstSlider = $(".slider--TIMELINE.first-slider");
            const secondSlider = $(".slider--TIMELINE.second-slider");
            const firstSliderHeight = firstSlider.find(".slick-list").height();
            const secondSliderHeight = secondSlider
              .find(".slick-list")
              .height();

            if (firstSlider.hasClass("closed")) {
              setTimeout(function () {
                secondSlider.css("height", secondSliderHeight);
              }, 500);
              firstSlider.css("height", "0");
            } else {
              setTimeout(function () {
                firstSlider.css("height", firstSliderHeight);
              }, 500);
              secondSlider.css("height", "0");
            }
          }, 500);
        }
      });

      $(".review__slick", context)
        .once("initSlider")
        .each(function () {
          const $this = $(this);
          const $dir = false;

          $this.not('.slick-initialized').addClass("is_initiated").slick({
            dots: true,
            infinite: true,
            arrows: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            cssEase: "linear",
            adaptiveHeight: true,
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
        });

      $(".retailers .cardgrid__content .layout", context).not('.slick-initialized').addClass('slider').slick({
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4444,
        centerPadding: '35px',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              centerPadding: '35px',
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              centerPadding: '20px',
            }
          },
          {
            breakpoint: 420,
            arrows: false,
            settings: {
              slidesToShow: 1.85,
              slidesToScroll: 1,
              centerPadding: '40px',
            }
          }
        ]
      });
    }
  };

})(jQuery, Drupal);
